import { WeixinProfilerResponse, WeixinProfilerResponseV2 } from '@/models/weixin'
import { apiClient } from './http'
import Toast from '@/components/common/popup/toast.vue'
import { i18n } from '@/i18n'
const $t = i18n.global.t
import {
  SmsVerificationRequest,
  GetSMSCodeByModifyRequest,
  EditUserInfoRequest,
} from '@/models/login'

/**
 * @description V2 获取用户信息
 */
// export const queryUserProfieV2 = async (): Promise<WeixinProfilerResponse> => {
//     const endpoint = '/auth/app/userInfo'
//     try {
//         const res = await apiClient({
//             url: endpoint,
//             method: 'get'
//         })
//         return await Promise.resolve(res)
//     } catch (error) {
//         return await Promise.reject(error)
//     }
// }

/**
 * @description V2.1 获取用户信息
 */
export const queryUserProfie = async (): Promise<WeixinProfilerResponseV2> => {
  const endpoint = '/system/social/getSocialInfo'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'get',
    })
    return await Promise.resolve(res)
  } catch (error) {
    return await Promise.reject(error)
  }
}

/**
 * @description V2 编辑用户信息
 */
// export const editUserInfo = async (data: EditUserInfoRequest) => {
//     const endpoint = '/system/social/editSocialInfo'
//     try {
//         const res = await apiClient({
//             url: endpoint,
//             method: 'put',
//             data
//         })
//         return await Promise.resolve(res)
//     } catch (error) {
//         return await Promise.reject(error)
//     }
// }
export const editUserInfo = async (data: EditUserInfoRequest) => {
  const endpoint = '/system/social/editSocialInfo'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'post',
      data,
    })
    return await Promise.resolve(res)
  } catch (error) {
    return await Promise.reject(error)
  }
}

/**
 * @description 修改用户手机号，用户通过滑动验证码验证后的成功反馈接口
 */
export const getSmsCodeByModifyPhoneNumber = async (
  data: GetSMSCodeByModifyRequest,
): Promise<any> => {
  const endpoint = '/user/sms/unbind'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'post',
      data,
    })
    return await Promise.resolve(res)
  } catch (error: any) {
    const { data } = error
    const { code, message } = data
    if (code == 'MSS_ERR_USER_PHONE_NUMBER_ALREADY_BOUND') {
      useToast({
        component: Toast,
        props: {
          icon: 'error',
          title: $t('profilePage.changePhoneNumberPage.errorToast1.title'),
        },
      })
    } else if (code == 'MSS_ERR_SMS_SERVICE_ERROR') {
      useToast({
        component: Toast,
        props: {
          icon: 'error',
          title: $t('profilePage.changePhoneNumberPage.errorToast2.title'),
        },
      })
    }
    // if (code == 'MSS_ERR_SMS_CODE_NOT_MATCH') {
    //     useToast({
    //         component: Toast,
    //         props: {
    //             icon: 'error',
    //             title: $t('bindingPhonePage.toast2.title'),
    //             content: $t('bindingPhonePage.toast2.content'),
    //         },
    //     })
    // } else if (code == 'MSS_ERR_FAILED') {
    //     useToast({
    //         component: Toast,
    //         props: {
    //             icon: 'error',
    //             title: code,
    //             content: message,
    //         },
    //     })
    // } else if (code === 'MSS_ERR_SMS_UNBIND_VERIFICATION_FAILED') {
    //     useToast({
    //         component: Toast,
    //         props: {
    //             icon: 'error',
    //             title: code,
    //             content: message,
    //         },
    //     })
    // } else {
    //     useToast({
    //         component: Toast,
    //         props: {
    //             icon: 'error',
    //             title: code,
    //             content: message,
    //         },
    //     })
    // }
    return await Promise.reject(error)
  }
}

/**
 * @description 短信验证码验证并更改用户手机号
 */
export const modifyUserPhoneNubmerVerification = async (
  data: SmsVerificationRequest,
): Promise<any> => {
  const endpoint = '/user/sms/unbind-verify'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'post',
      data,
    })
    useToast({
      component: Toast,
      props: {
        icon: 'success',
        title: $t('profilePage.changePhoneNumberPage.successToast.title'),
      },
    })
    return await Promise.resolve(res)
  } catch (error: any) {
    const { data } = error
    const { code, message } = data
    if (code == 'MSS_ERR_SMS_CODE_NOT_MATCH') {
      useToast({
        component: Toast,
        props: {
          icon: 'error',
          title: $t('bindingPhonePage.toast2.title'),
          content: $t('bindingPhonePage.toast2.content'),
        },
      })
    } else if (code == 'MSS_ERR_FAILED') {
      useToast({
        component: Toast,
        props: {
          icon: 'error',
          title: code,
          content: message,
        },
      })
    } else {
      useToast({
        component: Toast,
        props: {
          icon: 'error',
          title: code,
          content: message,
        },
      })
    }
    return await Promise.reject(error)
  }
}

/**
 * @description V2 用戶註銷賬戶
 */
export const deleteAccountV2 = async () => {
  const endpoint = '/system/social/logOff'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'post',
    })
    return await Promise.resolve(res)
  } catch (error) {
    return await Promise.reject(error)
  }
}

/**
 * @description V2 用戶登出
 */
export const userLogout = async () => {
  const endpoint = '/system/userLoginLog/insert'
  try {
    const res = await apiClient({
      url: endpoint,
      method: 'get',
      params: { operation: '退出' },
    })
    return await Promise.resolve(res)
  } catch (error) {
    return await Promise.reject(error)
  }
}
